import Point from "../entities/Point";
import RedPoint from "../entities/RedPoint";
import generatePoints from "../utils/generator/generatePoints";
import { normalizeRadian } from "../utils/math/normalizeRadian";
import { Coord, RedPointRadianInfo } from "../types/Interface";
import { rootEventBus, EnumRootEventBus } from "./RootEventBus";
import getAngleBetweenPoints from "../utils/math/getAngleBtwPoints";


export default class BasePointManager {
  static instance: BasePointManager;
  rootEventBus = rootEventBus;

  cCoord: Coord;
  circleRadius: number;
  pointRadiansBeforeAnim: number[] = []
  pointInitialRadians: number[] = [];
  pointRadians: number[] = [];
  pointRefRadians: number[] = [];
  pointRedCoords: Coord[] = [];
  selectedRedPointTag: string = "";
  circlePoint: Point;
  RedPointsArr: RedPoint[] = [];

  constructor(cCoord: Coord, CIRCLE_RADIUS: number, RADIANS: number[]) {
    if (!BasePointManager.instance) {
      BasePointManager.instance = this;
    }
    const radians = RADIANS.map(r => normalizeRadian(r));
    this.cCoord = cCoord;

    this.circleRadius = CIRCLE_RADIUS;
    this.pointRadiansBeforeAnim = [...radians];
    this.pointInitialRadians = [...radians];
    this.pointRefRadians = [...radians];
    this.pointRadians = radians;

    this.RedPointsArr = Array(radians.length)
      .fill(null)
      .map((_, vI) => `p${vI + 1}`)
      .map(pT => new RedPoint(pT, this.cCoord, (pT: string) => this.setSelectedRedPointTag(pT), () => this.setSelectedRedPointTag("")));

    this.circlePoint = new Point(this.cCoord);
    this.pointRedCoords = generatePoints(this.cCoord, this.pointRadians, this.circleRadius);

    this.rootEventBus.on(EnumRootEventBus.setPointerMove, (coord: Coord) => this.handleCursor(coord));
    this.rootEventBus.on(EnumRootEventBus.setPointerUp, () => this.setSelectedRedPointTag(""));
    this.rootEventBus.on(EnumRootEventBus.setRefRadians, () => this.setRefRadians());
    this.rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.handleStartedCircleAnim())
    this.rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.handleCompletedCircleAnim())
  }

  static getInstance = () => BasePointManager.instance;
  getPointTag = (n: number) => `p${n + 1}`;
  clearAll = () => [this.circlePoint, ...this.RedPointsArr].forEach(p => p.clear());
  setAllVisible = (v: boolean) => [this.circlePoint, ...this.RedPointsArr].forEach(p => {
    p.visible = v;
    p.interactive = v;
  });
  getRadians = () => this.pointRadians;
  getInitialRadians = () => this.pointInitialRadians;
  getRefRadians = () => this.pointRefRadians;
  getRedPoints = () => this.RedPointsArr;
  getPoints = () => [this.circlePoint, ...this.RedPointsArr];
  getPointsCoord = () => [this.cCoord, ...this.pointRedCoords];
  getRedPointsCoord = () => this.pointRedCoords;
  addSetCoordExtraCode = (cb: () => void) => this.addSetCoordExtraCode = cb;
  setSelectedRedPointTag (PointTag: string) {
    this.selectedRedPointTag = PointTag;
    const points = this.getRedPoints();
    points.forEach(p => p.eventMode = PointTag !== "" ? "none" : "static");
  }
  setRefRadians = () => this.pointRefRadians = [...this.pointRadians];
  handleStartedCircleAnim = () => {
    this.setAllVisible(false);
    this.pointRadiansBeforeAnim = [...this.pointRadians];
    this.pointRadians = [...this.pointInitialRadians];
    this.setCoord();
  }
  handleCompletedCircleAnim = () => {
    this.setAllVisible(true);
    this.pointRadians = [...this.pointRadiansBeforeAnim];
   
    const redPointArr: RedPointRadianInfo[] = this.pointRadiansBeforeAnim
      .map((radian, rI) => ({ pTag: this.getPointTag(rI), radian }));
    this.setRadian(redPointArr, false);
  }
 
  setCoord() { this._setCoord() };
  setRadian(pointInfoArr: RedPointRadianInfo[], isSlider = false) { this._setRadian(pointInfoArr, isSlider) };

  draw() {
    const points = this.getPoints();
    [this.circlePoint, ...this.RedPointsArr].forEach((p, pI) => p.draw(points[pI]));
  }
  handleCursor(coord: Coord) {
    if (this.selectedRedPointTag == "") {
      return
    }
    let radian = getAngleBetweenPoints(this.cCoord, coord);
    this.setRadian([{ pTag: this.selectedRedPointTag, radian }])
  }
  _setRadian(pointInfoArr: RedPointRadianInfo[], isSlider = false) {
    const points = this.getRedPoints();
    points.forEach((p, pI) => {
      pointInfoArr.forEach((pInfo) => {
        if (p.tag == pInfo.pTag) {
          const radian = normalizeRadian(pInfo.radian);
          this.pointRadians[pI] = radian;
          if (isSlider == false) {
            this.pointRefRadians[pI] = radian
          };
          this.setCoord();
        }
      })
    });
  }
  _setCoord() {
    this.pointRedCoords = generatePoints(this.cCoord, this.pointRadians, this.circleRadius);
    this.RedPointsArr.forEach((point, pIndex) => Object.assign(point, this.pointRedCoords[pIndex]));
    this.rootEventBus.emit(EnumRootEventBus.drawElements);
  }
}